import {useState, useEffect} from 'react';
import {isMobile} from 'react-device-detect';
import {loadMintedProject} from 'nft/mint.js';
import sampleRateChooser from 'engine/SampleRateChooser.js';
import {lstorage} from 'utils/lstorage.js';
import startaudiocontext from 'startaudiocontext';
import {LOW_SAMPLE_RATE, HIGH_SAMPLE_RATE} from 'constants/sample-rates.js';
import {checkLocalProjects} from "utils/checkLocalProjects.js";
import Tone from 'tone';
import {setupDropFiles} from '../DropFiles.js';
import KeyboardEngine from 'keyboard/KeyboardEngine';
import EthereumCache from 'decentralized/cache/EthereumCache.js';
import ethereum from 'decentralized/ethereum.js';
import accounts from 'accounts/Accounts.js';
import EthereumSoundsSearcher from 'search/EthereumSoundsSearcher.js';
import Scripting from 'scripting/Scripting.js';

var AudioContext = window.AudioContext || window.webkitAudioContext;

export const useSequencer = (props, contextLoaded=true, badScroll=true) => {
    let [ethereumCache, setEthereumCache] = useState(new EthereumCache(props.store));
    let [ethereumSearcher, setEthereumSearcher] = useState(undefined);
    let [sequencerEngine, setSequencerEngine] = useState(undefined);

    useEffect(() => {
        if (!contextLoaded) {
            return;
        }

        var root = document.getElementsByTagName( 'html' )[0]; // '0' to assign the first (and only `HTML` tag)
        if (badScroll) {
            root.setAttribute( 'class', 'bad-scroll' );
        }

        let latencyHint;
        if (!props.skipSampleRate) {
            if (//!window.isNFT &&
                false && (lstorage.getItem("sampleRate") || lstorage.getItem("latencyHint"))) {
                let sampleRate = lstorage.getItem("sampleRate");
                let hint = lstorage.getItem("latencyHint") || "interactive";
                console.log('setting sample rate from lstorage');
                let context = new AudioContext({
                
                    sampleRate: sampleRate ? parseFloat(lstorage.getItem("sampleRate")) : LOW_SAMPLE_RATE,
                    latencyHint: hint
                });
                Tone.setContext(context);
                window.context = context;
                latencyHint = hint;
                sampleRateChooser.updateBuffer();
                console.log("USING NEW SAMPLE RATE =", context.sampleRate);
                //window.isNFT=true;
            } else {
                if (isMobile) {
                    sampleRateChooser.setSampleRate(
                        LOW_SAMPLE_RATE);
                } else {
                    sampleRateChooser.setSampleRate(
                        HIGH_SAMPLE_RATE);
                }
           }

            if (window.context) {
                console.log('after setting sample rate it was =', window.context.sampleRate);
            }

            if (!window.isNFT) {
                accounts.setStore(props.store);
                accounts.setEthereum(ethereum);
                accounts.checkLogin()
                    .then(() => {
                        ethereum.guilds.initGuilds();
                        ethereum.guilds.acceptAnyNewRequests();
                        accounts.appear();
                });
            }
        }

        startaudiocontext(Tone.Master.context, ".editor");
        
        checkLocalProjects();
        ethereum.cache = ethereumCache;
        ethereum.cache.loadIndex();
        
        ethereum.store = props.store;
        ethereum.crypto.store = props.store;

        import('engine/ScriptableSequencer.js').then(
            ScriptableSequencer => {
                let engine = new ScriptableSequencer.default(props.store);
                engine.latencyHint = latencyHint;
                engine.setScripting(new Scripting(engine));
                engine.connectToKeyboardEngine(new KeyboardEngine(engine));
                engine.ethereumCache = ethereumCache;
                setEthereumSearcher(new EthereumSoundsSearcher(ethereumCache, engine));
                if (props.setSequencerEngine) {
                    props.setSequencerEngine(engine);
                }
                setSequencerEngine(engine);

                window.addEventListener("beforeunload", (event) => {
                    event.returnValue = "Please dont leave";
                    return event;
                });

                let sequenceId = sequencerEngine !== undefined ?
                    props.sequencerEngine.getSequenceId() :
                    props.match && props.match.params.sequenceId != undefined ? 
                    props.match.params.sequenceId :
                    null;

                let projectId = undefined;// props.match && props.match.params.projectId;
                let tokenId = undefined ; //props.match && props.match.params.tokenId;

                let search = props.location && props.location.search;
                if (search) {
                    let tokens = search.split("=");
                    for (let i=0; i < tokens.length; i+=2) {
                        if (tokens[i].includes("token")) {
                            let tokenId = tokens[i+1];
                            if (tokenId !== undefined) {
                                engine.tokenID = parseInt(tokenId);
                                break;
                            }
                        }
                    }
                }

                /*
                  window.projectId = "QmbUTc8CQ2w44kaTLAfSni1eYNXHhhC4VEbniWkzHSwokn";
                  //window.isNFT = true;
                  window._isNFT = true;
                */

                if (projectId !== undefined && tokenId !== undefined) {
                    loadMintedProject(engine, projectId, tokenId);
                } else if (window.projectId) {
                    engine.loadSequence(window.projectId);
                } else if (sequenceId == null) {
                    engine.loadNewSequence();
                } else {
                    if (window.isNFT) {
                        engine.loadSequence(sequenceId);
                    } else {
                        accounts.checkLogin().then(
                            () => engine.loadSequence(sequenceId));
                    }
                }

                setupDropFiles(engine);
            });
    }, [contextLoaded]);

    return [ethereumCache, sequencerEngine, ethereumSearcher];
};
